/* eslint-disable -- UX wireframe; not held to app lint rules */
import { T } from "../../tokens";
import ZiniHubWizardApp from "../ZiniHub/shared/ZiniHubWizardApp";
import { ROUTES } from "../ZiniHub/shared/zinihubRoutes";
import { IA } from "../ZiniHub/shared/zinihubIA";
import { getShellsForApp } from "../ZiniHub/shared/zinihubShells";
import { CUST_FLOWS } from "../ZiniHub/shared/zinihubCustFlows";
import { CUST_ISSUES } from "../ZiniHub/shared/zinihubIssues";
import { FOLDER_STRUCTURE, TECH_STACK, CONFIGS } from "../ZiniHub/shared/zinihubMeta";

const { shells, previewScreenByShell } = getShellsForApp("customer");

const CUSTOMER_APP_CONFIG = {
  id: "customer",
  title: "ZiniHub Customer",
  domain: "visitmyhub.online",
  subtitle: "Design Wizard",
  flows: CUST_FLOWS,
  routes: ROUTES.customer,
  ia: IA.customer,
  shells,
  shellPreviews: previewScreenByShell,
  issues: CUST_ISSUES,
  accentColor: T.teal,
  folderStructure: FOLDER_STRUCTURE.customer,
  techStack: TECH_STACK.customer,
  configs: CONFIGS.customer,
};

export default function ZiniHubCustUXWizard() {
  return <ZiniHubWizardApp appConfig={CUSTOMER_APP_CONFIG} />;
}
